import React, { useContext } from 'react';
import { prettyDate } from '../../../config/dateFormatting';
import { IAlreadyBooked, IMenuItem } from '../../../interface/interface';
import MenuItemContainerWeekBooking from './MenuItemContainerWeekBooking';
import { v4 as uuidv4 } from 'uuid';
import { AlreadyBookedBatch } from './AlreadyBookedBatch';
import { makeStyles } from '@material-ui/core';
import { dateHasAvailableSeatings } from '../../../utils/dateHasAvailableSeatings';
import { OfficeContext } from '../../../config/Context';

const useStyles = makeStyles((theme: any) => ({
    container: {
        padding: 15,
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        height: "fit-content",
        minHeight: "12rem"
    },
    dateContainer:{
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        fontWeight: 'bold',
        fontSize: 18
    },
    contentDisabled:{
        width: "100%",
        height: "100%",
        background: 'white',
        opacity: "0.6",
    }
}));

interface Props {
    date: Date;
    menuItemsOnDates: IMenuItem[][];
    index:number;
    setMenuItemsOnDates: React.Dispatch<React.SetStateAction<IMenuItem[][]>>;
    alreadyBookedOnDate?: boolean;
    alreadyBookings?: IAlreadyBooked[];
    eaterGroupBookings?: IAlreadyBooked[];
    eaterGroupName: string;
    seatingAvaiable: Map<string,string>;
    seatingCapacities: Map<string,string>;
}

export const BookingContainer: React.FC<Props> = ({
    date,
    index,
    menuItemsOnDates,
    setMenuItemsOnDates, 
    alreadyBookings, 
    eaterGroupBookings, 
    eaterGroupName,
    seatingAvaiable,
    seatingCapacities}) => {
    // Styling
    const classes = useStyles()

    // Display MenuItemsOnDate
    var menuItemsOnDateView : any [] = []

    // Context
    const officeContext = useContext(OfficeContext);

    if(menuItemsOnDates[index].length > 0){
        if(dateHasAvailableSeatings(menuItemsOnDates[index],seatingAvaiable)){
            menuItemsOnDateView.push(
                <div className={classes.dateContainer}>
                    {prettyDate(date,false,true)}
                    { alreadyBookings  && eaterGroupBookings && <AlreadyBookedBatch alreadyBookings={alreadyBookings} eaterGroupBookings={eaterGroupBookings} eaterGroupName={eaterGroupName} key={uuidv4()} />}
                </div>
            )
            const canCommentOnBookings = officeContext?.office?.content.officeSettings ? officeContext?.office?.content.officeSettings.canCommentOnBookings : false
            menuItemsOnDates[index].forEach((menuItemOnDate) => {
                menuItemsOnDateView.push(
                    <MenuItemContainerWeekBooking
                        key={menuItemOnDate.dish.content.id}
                        selectedDate={date}
                        menuItemOnDate={menuItemOnDate}
                        menuItemsOnDates={menuItemsOnDates}
                        price={menuItemOnDate.price}
                        index={index}
                        setMenuItemsOnDates={setMenuItemsOnDates}
                        eaterGroupBookings={eaterGroupBookings}
                        eaterGroupName={eaterGroupName}
                        seatingCapacities={seatingCapacities}
                        canCommentOnBookings={canCommentOnBookings}
                    />
                )  
            })
        } else {
            menuItemsOnDateView.push(
                <div className={classes.contentDisabled} key={uuidv4()}>
                    <div className={classes.dateContainer}>
                        {prettyDate(date,false,true)}
                        { alreadyBookings  && eaterGroupBookings && <AlreadyBookedBatch alreadyBookings={alreadyBookings} eaterGroupBookings={eaterGroupBookings} eaterGroupName={eaterGroupName} key={uuidv4()} />}
                    </div>
                    <div>Option no longer avaiable</div>
                </div>
            )
        }
    } else {
        menuItemsOnDateView.push(
            <div className={classes.contentDisabled} key={uuidv4()}>
                <div className={classes.dateContainer}>
                        {prettyDate(date,false,true)}
                    </div>
                <div>No seatings on the date</div>
            </div>
        )
    }

    return (
        <div className={classes.container}>
            {menuItemsOnDateView}
        </div>
    );
}
